import { Box, Button, Paper } from '@mui/material'
import { useAuth } from 'Components/Auth'
import { useFollowingsQuery, useFollowMutation, useUnfollowMutation, useUserQuery } from 'Queries/Users'
import { navigateToLoginModal, navigateToProfilePage } from 'Scenes/navigators'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

import { UserInfo } from './UserInfo'

export const CollaboratorCard = ({ collaborator, isPreview, waypointUsers }) => {
  const { data: user } = useUserQuery(collaborator.user_id)
  const { id, isAuthorized } = useAuth()
  const { data: userFollowing = [] } = useFollowingsQuery()
  const { mutate: follow } = useFollowMutation()
  const { mutate: unfollow } = useUnfollowMutation()

  const showFollowButton = collaborator.user_id && collaborator.user_id !== id
  const isUserFollowingCollaborator = !!userFollowing.find((item) => item.user_id === collaborator.user_id)

  const waypointUser = waypointUsers?.find((item) => item?.xuid === collaborator.halowaypoint_user_xuid)

  const handleFollowClick = () => {
    if (!isAuthorized) {
      navigateToLoginModal()
    } else {
      isUserFollowingCollaborator ? unfollow(collaborator.user_id) : follow(collaborator.user_id)
    }
  }

  const goToUserProfilePage = () => {
    !isPreview && collaborator.user_id && navigateToProfilePage(collaborator.user_id)
  }

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      p={2}
      gap={2}
      component={Paper}
    >
      <UserInfo
        handleUserClick={goToUserProfilePage}
        info={collaborator?.role || waypointUser?.gamer_tag}
        isWaypointUser={!user}
        login={user ? user?.login : waypointUser?.display_name}
        userImages={user?.user_images}
      />
      {showFollowButton && (
        <Button
          sx={{ background: 'transparent', minWidth: 'unset', '&:hover': { background: 'transparent' } }}
          onClick={handleFollowClick}
        >
          <FAIcon
            iconFontSize={16}
            iconClassName={isUserFollowingCollaborator ? FA_ICONS.USER_MINUS : FA_ICONS.USER_PLUS}
            color={isUserFollowingCollaborator ? 'text.secondary' : 'secondary.main'}
          />
        </Button>
      )}
    </Box>
  )
}
